import $ from 'jquery';


function createSelectorInput() {
    const input = document.createElement('input');

    input.setAttribute('name', 'selector[]');
    input.setAttribute('placeholder', 'Selector CSS');
    input.setAttribute('aria-label', 'Selector CSS');
    input.setAttribute('aria-label', 'Selector CSS');

    return input;
}

$(() => {
    const $addButton = $('[data-add-selector]');
    const $inputsContainer = $('.wpa-code-admin-page--form--selectors-inputs');

    $addButton.click((event) => {
        event.preventDefault();

        const input = createSelectorInput();
        $inputsContainer.append(input);
    });
});